function createTrunkGeom(lastRing) {
  const positions = [];
  const cells = [];

  const lastIndex = lastRing.spline.length;
  lastRing.spline.forEach((p, i) => {
    const ni = (i + 1) % lastRing.spline.length;
    positions.push(p);
    cells.push([i, ni, lastIndex]);
  });
  positions.push([0, 0, 0]);
  return {
    positions,
    cells,
  };
}

export default createTrunkGeom;
